import { render, staticRenderFns } from "./orderList1.vue?vue&type=template&id=1483583a&scoped=true&"
import script from "./orderList1.vue?vue&type=script&lang=js&"
export * from "./orderList1.vue?vue&type=script&lang=js&"
import style0 from "./orderList1.vue?vue&type=style&index=0&id=1483583a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1483583a",
  null
  
)

export default component.exports